import styled from 'styled-components'
import { ErrorMessage } from '@sketch/components'

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  position: absolute;
  top: 8px;
  right: 0px;

  /* It was used padding-right here, because the dropdown wraps the text, anticipating that */
  /* the button is to close to the parent limits */
  padding-right: 8px;
`

export const Message = styled(ErrorMessage)`
  position: relative;
  && div > [role='img'] {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
    opacity: 0.55;
  }
`

export const InfoMessageTextLine = styled.span`
  display: inline-block;
  max-width: calc(100% - 72px);
`

export const InfoMessageContent = styled.span`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  && svg {
    height: 24px;
    width: 24px;
  }
`
